import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  ExternalLinkComponent,
  getColumnKey,
  ImageThumbnailComponent,
  ImageThumbnailUnsupportedComponent,
  NoDataComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { AdminBannerCollectionItem } from '../../models/admin-banner-collection-item';
import { AdminBannerCollectionFilter } from '../../models/admin-banner-collection-filter';
import { isNotNil } from '@web/utils';
import { AdminBannerStatusPipe } from '../../pipes/admin-banner-status.pipe';
import { BannerLocationTypePipe } from '../../../shared/pipes/banner-location-type.pipe';

@Component({
  selector: 'app-admin-banner-list-custom-cell-template',
  imports: [
    BannerLocationTypePipe,
    CommonModule,
    ImageThumbnailComponent,
    NgOptimizedImage,
    ImageThumbnailUnsupportedComponent,
    ExternalLinkComponent,
    NoDataComponent,
    AdminBannerStatusPipe,
    TableBodyNoReferenceCellComponent,
  ],
  templateUrl: './admin-banner-list-custom-cell-template.component.html',
  styleUrl: './admin-banner-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBannerListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<AdminBannerCollectionItem, AdminBannerCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<AdminBannerCollectionItem>();

  protected readonly getColumnKey = getColumnKey<AdminBannerCollectionItem>;
  protected readonly isNotNil = isNotNil;
}
